import {
    BOOKMARK,
    FILTER_LAST_3_MONTHS,
    FILTER_LAST_6_MONTHS,
    JobsTypes,
    RONE,
} from 'components/Sidebar/types';
import { updateMonth } from './dates';

interface SearchFuncTypes {
    data: JobsTypes[];
    searchValue: string;
    isBookmarkSelected: boolean;
    monthFilter: string;
}

export const filterValues = (type: string, data: JobsTypes[]) => {
    switch (type) {
        case FILTER_LAST_6_MONTHS: {
            const sixMonthsAgo = updateMonth(-6);
            const filteredData = data.filter(
                (item) => new Date(item.created_at) >= new Date(sixMonthsAgo),
            );
            return filteredData;
        }
        case FILTER_LAST_3_MONTHS: {
            const threeMonthsAgo = updateMonth(-3);
            const filteredData = data.filter(
                (item) => new Date(item.created_at) >= new Date(threeMonthsAgo),
            );
            return filteredData;
        }
        case BOOKMARK: {
            const filteredData = data.filter((item) => item.isSaved);
            return filteredData;
        }
        case RONE: {
            const filteredData = data.filter((item) => !!item.job_order_id);
            return filteredData;
        }
        default:
            return data;
    }
};

export const searchJob = ({
    data,
    searchValue,
    isBookmarkSelected,
    monthFilter,
}: SearchFuncTypes) => {
    // Split the search string into words
    if (!isBookmarkSelected && !monthFilter && !searchValue) {
        return [];
    }

    let filteredData: JobsTypes[] | null = null;
    if (isBookmarkSelected) {
        filteredData = filterValues(BOOKMARK, data);
    }
    filteredData = filterValues(monthFilter, filteredData ?? data);

    if (!searchValue) {
        return filteredData;
    }

    const searchWords = searchValue.toLowerCase().split(' ');

    return filteredData.filter((item) => {
        const titleLowerCase = item.title.toLowerCase();
        const intakeNotesLowerCase = item.intake_notes.toLocaleLowerCase();
        const messages = item.messages ?? [];

        // Every search word must match at least one field
        return searchWords.every((word) => {
            const directMatch = [titleLowerCase, intakeNotesLowerCase].some((field) =>
                field.includes(word),
            );

            const messageMatch = messages.some(
                (msg) =>
                    (typeof msg?.brand === 'string' && msg.brand.toLowerCase().includes(word)) ||
                    (typeof msg?.country === 'string' && msg.country.toLowerCase().includes(word)),
            );

            return directMatch || messageMatch;
        });
    });
};
